import React from "react";
import "./NewBooking.scss";
import { connect } from "react-redux";
import { ApplicationState } from "../../appState";
import NewBookingForm from "./NewBookingForm";
import CardRegistration from "../Cards/CardRegistration";
import { BookingWidgetModeKind } from "../BookingTemplate/BookingTemplateEntities";
import BookingPageLoading from "./Widget/BookingPageLoading";
import BookingButton from "./Widget/BookingButton";
import { TncFooter } from "./Widget/TncFooter";
import { BookingFormKind } from "../UILogicControl/UILogicControlEntities";
import { ParcelBookingForm } from "./Parcel/ParcelBookingForm";
import { MaybeBookingTemplateNameField } from "./OptionalParts/MaybeBookingTemplateNameField";
import { MaybeParcelModeSelector } from "./OptionalParts/MaybeParcelModeSelector";
import { MaybeAccountOption } from "./OptionalParts/MaybeAccountOption";
import { OptionalUI } from "./OptionalParts/OptionalUI";
import { MaybeVoiceRecordingConsent } from "./Widget/MaybeVoiceRecordingConsent";

/**
 * The booking edit widget in desktop layout mode.
 */
const NewBooking : React.FC<ReduxProps> = (props) => {
    
    const isTemplateModeOn = props.BookingWidgetMode !== BookingWidgetModeKind.Booking;
    const isParcelMode = props.ActiveBookingWidget === BookingFormKind.ParcelBooking;

    const bookingPanelClass = props.ShouldShowBookingTabs ? "booking-form-panel" : "booking-form-panel booking-form-panel-without-tabs";

    return (
        <div>
            <div className={bookingPanelClass} >  
                <div className="booking-form-content">
                    <MaybeBookingTemplateNameField />
                    <MaybeAccountOption />
                    <MaybeParcelModeSelector />
                    {isParcelMode ? <ParcelBookingForm /> : <NewBookingForm /> }
                    <BookingButton />
                    <MaybeVoiceRecordingConsent />
                </div>
                {!isTemplateModeOn && <TncFooter /> }      
            </div>

            {props.IsCardRegistrationPanelOpen && <CardRegistration CardRegistrationPanelParent="BookingForm" />}  
            <BookingPageLoading/>              
        </div>           
    );
}

interface ReduxProps {
    BookingWidgetMode: BookingWidgetModeKind;
    IsCardRegistrationPanelOpen: boolean;
    ActiveBookingWidget: BookingFormKind;
    ShouldShowBookingTabs: boolean;
}

function GetPropsFromRedux(state: ApplicationState): ReduxProps {
    return {
        BookingWidgetMode: state.uiLogicControl.BookingForm.BookingWidgetMode,
        IsCardRegistrationPanelOpen: state.payment.IsCardRegistrationPanelOpen,
        ActiveBookingWidget: state.uiLogicControl.BookingForm.ActiveBookingForm,
        ShouldShowBookingTabs: OptionalUI.BookingTabs(state),
    };
}

export default connect(GetPropsFromRedux)(NewBooking);